import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { createI18n } from 'vue-i18n'
import router from './router';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { Vue3Mq, MqResponsive } from 'vue3-mq'

import en from './lang/en.json';
import zh from './lang/zh.json';

const i18n = createI18n({
    legacy: false, 
    locale: 'zh',
    fallbackLocale: 'zh', 
    messages: {
      en,
      zh
    }
  });


const app = createApp(App);
app.use(i18n);
app.use(router)
app.use(ElementPlus)
app.use(ElementPlusIconsVue)

// 引入移动端
app.use(Vue3Mq)
// 全局注册移动端组件
app.component('MqResponsive', MqResponsive)

// 全局注册图标组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.mount('#app')


// app.vue写在script里面  main.js写在app挂载完之后
const debounce = (fn, delay) => {
  let timer
   return (...args) => {
     if (timer) {
       clearTimeout(timer)
     }
     timer = setTimeout(() => {
       fn(...args)
     }, delay)
   }
}
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
   constructor(callback) {
     callback = debounce(callback, 200);
     super(callback);
   }
}